import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/** Ganti password sendiri. `force`=true → wajib ganti (password sementara dari admin), tidak bisa ditutup. */
export function ChangePasswordDialog({ open, onClose, force = false }) {
  const { user, setUser, logout } = useApp();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) { toast.error("Konfirmasi password tidak sama"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { currentPassword: f.current, newPassword: f.next });
      toast.success("Password berhasil diganti / 密码已更新");
      setUser({ ...user, mustChangePassword: false });
      setF({ current: "", next: "", confirm: "" });
      onClose?.();
    } catch (ex) { toast.error(fmtErr(ex)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !force) onClose?.(); }}>
      <DialogContent className="max-w-md border-slate-800 bg-[#0D1524] text-slate-100" data-testid="change-password-dialog" onInteractOutside={(e) => force && e.preventDefault()} onEscapeKeyDown={(e) => force && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display"><KeyRound className="h-4 w-4 text-amber-400" />{force ? "Wajib Ganti Password" : "Ganti Password"} <span className="cn text-xs font-normal text-slate-500">修改密码</span></DialogTitle>
        </DialogHeader>
        {force && <p className="rounded border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-200" data-testid="change-password-force-note">Anda login dengan password sementara dari admin. Buat password baru untuk melanjutkan.</p>}
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1"><Label className="text-xs text-slate-400">{force ? "Password sementara" : "Password saat ini"}</Label>
            <Input type="password" required value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} className="border-slate-800 bg-slate-900/70" data-testid="change-password-current" /></div>
          <div className="space-y-1"><Label className="text-xs text-slate-400">Password baru (min. 6)</Label>
            <Input type="password" required minLength={6} value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} className="border-slate-800 bg-slate-900/70" data-testid="change-password-new" /></div>
          <div className="space-y-1"><Label className="text-xs text-slate-400">Ulangi password baru</Label>
            <Input type="password" required minLength={6} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="border-slate-800 bg-slate-900/70" data-testid="change-password-confirm" /></div>
          <div className="flex justify-end gap-2 pt-1">
            {force ? (
              <Button type="button" variant="ghost" className="text-slate-400" onClick={logout} data-testid="change-password-logout">Keluar</Button>
            ) : (
              <Button type="button" variant="outline" className="border-slate-700" onClick={onClose} data-testid="change-password-cancel">Batal</Button>
            )}
            <Button type="submit" disabled={busy} className="bg-sky-600 hover:bg-sky-500" data-testid="change-password-submit">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Simpan Password</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
